export default __webpack_public_path__ + "static/media/rotate.f12e4358.png";